var _rect, _path, _path2, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomepageTextwiz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 113,
    viewBox: "0 0 132 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 113.143,
    width: 18,
    height: 112.5,
    rx: 9,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2852 36C28.2852 31.0294 32.3146 27 37.2852 27V27C42.2557 27 46.2852 31.0294 46.2852 36V75.8571C46.2852 80.8277 42.2557 84.8571 37.2852 84.8571V84.8571C32.3146 84.8571 28.2852 80.8277 28.2852 75.8571V36Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.501C0 35.5304 4.02944 31.501 9 31.501V31.501C13.9706 31.501 18 35.5304 18 40.501V70.7153C18 75.6858 13.9706 79.7153 9 79.7153V79.7153C4.02944 79.7153 0 75.6858 0 70.7153V40.501Z",
    fill: "black",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 84.8574,
    y: 7.71387,
    width: 18,
    height: 96.4286,
    rx: 9,
    fill: "black",
    fillOpacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5723,
    y: 20.5713,
    width: 18,
    height: 70.7143,
    rx: 9,
    fill: "black",
    fillOpacity: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageTextwiz);
export default __webpack_public_path__ + "static/media/homepage_textwiz.69a6de33ad9103daeda71697abd29e3a.svg";
export { ForwardRef as ReactComponent };